import { useState } from 'react';

import { getStoredEmailVerified } from '@/lib/logto';
import { EmailGateStep } from './EmailGateStep';
import { WelcomeStep } from './WelcomeStep';
import { LinkCrStep } from './LinkCrStep';
import { DoneStep } from './DoneStep';

export interface OnboardingCompleteOpts {
  startTour?: boolean;
  navigateTo?: string;
}

interface OnboardingProps {
  onComplete: (opts?: OnboardingCompleteOpts) => void;
}

type Step = 'email' | 'welcome' | 'linkCr' | 'done';

/**
 * First-run wizard, rendered by AppShell INSTEAD of the route tree (no URL —
 * nothing to deep-link/back out of). Steps: conditional email gate →
 * welcome+nickname → link CR invite → done. Every step is best-effort except
 * the email gate (a broken Laravel surface is worse than a blocked wizard).
 */
export function Onboarding({ onComplete }: OnboardingProps) {
  // getStoredEmailVerified is sync (decodes the persisted id_token). `false`
  // gates; `true`/`null` (unknown — old session, standalone flow) do not.
  const [step, setStep] = useState<Step>(() =>
    getStoredEmailVerified() === false ? 'email' : 'welcome',
  );

  switch (step) {
    case 'email':
      return <EmailGateStep onVerified={() => setStep('welcome')} />;
    case 'welcome':
      return <WelcomeStep onNext={() => setStep('linkCr')} />;
    case 'linkCr':
      return (
        <LinkCrStep
          onLinkNow={() => onComplete({ navigateTo: '/duels/link' })}
          onLater={() => setStep('done')}
        />
      );
    case 'done':
      return (
        <DoneStep
          onTour={() => onComplete({ startTour: true })}
          onStart={() => onComplete()}
        />
      );
  }
}
